<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td style="text-align:left;padding-right:5px;">Platform Structure</td>
            <td style="text-align:left;padding-right:5px;">Platform Types</td>
            <td style="text-align:right;padding-right:5px;">Count</td>
        </tr>

        <tr *ngFor="let structure of platforms">
            <td>{{ structure.platformStructureType }}</td>
            <td>
                <ul style="padding:0;">
                    <li style="list-style: none;" *ngFor="let platformType of structure.platformTypes">{{ platformType
                        }}</li>
                </ul>
            </td>
            <td style="text-align:right;padding-right:5px;">{{ structure.count }}</td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td style="text-align:left;padding-right:5px;">Platform Structure</td>
            <td style="text-align:left;padding-right:5px;">Platform Types</td>
            <td style="text-align:right;padding-right:5px;">Count</td>
            <!--<td style="text-align:right;padding-right:5px;">Materials</td>-->
            <!--<td style="text-align:right;padding-right:5px;">Jacket Weight (tonne)</td>-->
            <!--<td style="text-align:right;padding-right:5px;">Topsides Weight (tonne)</td>-->
            <!--<td style="text-align:right;padding-right:5px;">Total Weight (tonne)</td>-->
        </tr>

        <tr *ngFor="let structure of platforms">
            <td>{{ structure.platformStructureType }}</td>
            <td>
                <ul style="padding:0;">
                    <li style="list-style: none;" *ngFor="let platformType of structure.platformTypes">{{ platformType
                        }}</li>
                </ul>
            </td>
            <td style="text-align:right;padding-right:5px;">{{ structure.count }}</td>
            <!--<td style="text-align:right;padding-right:5px;">-->
            <!--<table>-->
            <!--<tr *ngFor="let material of platform.materials">-->
            <!--<td>{{ material.description }}</td>-->
            <!--</tr>-->
            <!--</table>-->
            <!--</td>-->
            <!--<td style="text-align:right;padding-right:5px;">{{ platform.weightJacket }}</td>-->
            <!--<td style="text-align:right;padding-right:5px;">{{ platform.weightTopsides }}</td>-->
            <!--<td style="text-align:right;padding-right:5px;">{{ platform.weightTotal }}</td>-->
        </tr>

    </table>
</div>
</ng-template>